"use strict";

var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BodyProvider = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../kameleoonData"),
  _requester = require("../requester"),
  _utilities = require("../utilities"),
  _constants = require("./constants"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var BodyProvider = /*#__PURE__*/function () {
  function BodyProvider(a) {
    _classCallCheck(this, BodyProvider);
    _defineProperty(this, "prng", void 0), _defineProperty(this, "currentSize", 0), _defineProperty(this, "resultBody", []), _defineProperty(this, "hasUserAgent", !1), _defineProperty(this, "trackingVisitors", {}), this.prng = a;
  }
  return _createClass(BodyProvider, [{
    key: "getTrackingBody",
    value: function getTrackingBody() {
      var a = {
        body: this.resultBody.join("\n"),
        hasUserAgent: this.hasUserAgent
      };
      return this.cleanup(), a;
    }
  }, {
    key: "addData",
    value: function addData(a) {
      var b = a.visitorCode,
        c = a.variationData,
        d = a.visitorData,
        e = a.userAgent,
        f = a.isConsentProvided,
        g = a.isMappingIdentifier;
      var h = [],
        i = this.getVariationDataLines(c),
        j = this.getVisitorDataLines(d);
      return h.push.apply(h, _toConsumableArray(j).concat(_toConsumableArray(i))), this.addVisitorTrackingLines({
        visitorCode: b,
        lines: h,
        userAgent: e,
        isConsentProvided: f,
        isMappingIdentifier: g
      });
    }
  }, {
    key: "getVisitorDataLines",
    value: function getVisitorDataLines(a) {
      var b = [];
      var _iterator = _createForOfIteratorHelper(a),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          var _a = void 0;
          if (c.data.type === _kameleoonData.KameleoonData.Conversion || c.data.type === _kameleoonData.KameleoonData.PageView) {
            var _b = c.data.nonce;
            _b ? _a = _b : (_a = _utilities.Utilities.getNonce(this.prng), c.data.nonce = _a);
          }
          _a || (_a = _utilities.Utilities.getNonce(this.prng)), b.push(c.url + _requester.UrlParameter.Nonce + _a);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return b;
    }
  }, {
    key: "getVariationDataLines",
    value: function getVariationDataLines(a) {
      var _this = this;
      var b = [];
      return a.forEach(function (a) {
        b.push(_requester.UrlEventType.Experiment + _requester.UrlParameter.Id + a.experimentId + _requester.UrlParameter.VariationId + a.variationId + _requester.UrlParameter.Nonce + _utilities.Utilities.getNonce(_this.prng));
      }), b;
    }
  }, {
    key: "prepareVisitorBody",
    value: function prepareVisitorBody(a) {
      var _this$resultBody;
      var b = this.trackingVisitors[a];
      if (!b) return (0, _tsRes.Err)();
      var c = b.lines,
        d = b.userAgent,
        e = b.isMappingIdentifier,
        f = b.isConsentProvided,
        g = this.getIdentifier(a, e);
      if (c.length) c.forEach(function (a, b) {
        c[b] = a + g;
      }), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["Sending tracking request for unsent data ", " of visitor ", " with given (or not required) consent ", ""])), c, a, f);else if (f) {
        var _b2 = this.getActivityLine();
        c.push(_b2 + g), _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Sending tracking request for activity of visitor ", " with given consent"])), a);
      } else _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["No data to send for visitor ", " with no consent"])), a);
      d && c.length && (c[0] += _requester.UrlParameter.UserAgent + d, this.hasUserAgent = !0);
      var h = this.checkSize(c);
      return h.ok && (_this$resultBody = this.resultBody).push.apply(_this$resultBody, _toConsumableArray(c)), h;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.currentSize = 0, this.resultBody = [], this.hasUserAgent = !1, this.trackingVisitors = {};
    }
  }, {
    key: "checkSize",
    value: function checkSize(a) {
      var b = 0;
      return (b += a.reduce(function (a, b) {
        return a + b.length * _constants.SYMBOL_SIZE;
      }, 0), b + this.currentSize > _constants.MAX_BODY_SIZE) ? (0, _tsRes.Err)() : (this.currentSize += b, (0, _tsRes.Ok)());
    }
  }, {
    key: "addVisitorTrackingLines",
    value: function addVisitorTrackingLines(a) {
      var _this$trackingVisitor;
      var b = a.visitorCode,
        c = a.lines,
        d = a.userAgent,
        e = a.isConsentProvided,
        f = a.isMappingIdentifier;
      return this.trackingVisitors[b] ? (d && (this.trackingVisitors[b].userAgent = d), (_this$trackingVisitor = this.trackingVisitors[b].lines).push.apply(_this$trackingVisitor, _toConsumableArray(c))) : this.trackingVisitors[b] = {
        isMappingIdentifier: f,
        isConsentProvided: e,
        userAgent: d,
        lines: c
      }, this.prepareVisitorBody(b);
    }
  }, {
    key: "getActivityLine",
    value: function getActivityLine() {
      return _requester.UrlEventType.Activity + _requester.UrlParameter.Nonce + _utilities.Utilities.getNonce(this.prng);
    }
  }, {
    key: "getIdentifier",
    value: function getIdentifier(a, b) {
      var c = b ? _requester.UrlParameter.MappingValue : _requester.UrlParameter.VisitorCode;
      return c + a;
    }
  }]);
}();
exports.BodyProvider = BodyProvider;